import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetOne } from 'redux/actions/jewishness.actions';

import LayoutContainer from 'containers/LayoutContainer';
import JewishnessShow from 'views/public/JewishnessView/components/JewishnessShow';

import Loading from 'components/commons/Loading';

import 'views/public/JewishnessView/components/JewishnessShow/i18n';

const JewishnessShowContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const { loading, selectedItem: item } = useTypedSelector((state) => state.jewishness);

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <JewishnessShow item={item} />
      {loading && <Loading isModalMode message={i18next.t('JEWISHNESS_SHOW:LOADING')} />}
    </LayoutContainer>
  );
};

export default JewishnessShowContainer;
